import React from 'react';

export const LoadingOverlay: React.FC = () => {
  return (
    <div className='absolute inset-0 bg-white bg-opacity-80 backdrop-blur-sm flex items-center justify-center z-50'>
      <div className='flex flex-col items-center space-y-3'>
        <div className='animate-pulse drop-shadow-md'>
          <svg
              width='96'
              height='54'
              viewBox='0 0 192 107'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
              className='w-24 h-auto'
          >
            <path
                d='M0 107.001V0.000976563H27.5V107.001H0Z'
                fill='url(#paint0_linear)'
            />
            <path
                d='M37 78.001V46.001H68.5V78.001H37Z'
                fill='url(#paint1_linear)'
            />
            <path
                d='M81.5 107.001V0.000976563H141.5C141.5 0.000976563 162.002 -0.000954628 176.5 14.5019C191.25 29.2565 191.5 49.501 191.5 49.501V107.001H165V49.501C165 49.501 165 40.5 159 34C153 27.5 141.5 27.001 141.5 27.001H108V107.001H81.5Z'
                fill='url(#paint2_linear)'
            />
            <path
                d='M153 62.5C153 71.6127 145.389 79 136 79C126.611 79 119 71.6127 119 62.5C119 53.3873 126.611 46 136 46C145.389 46 153 53.3873 153 62.5Z'
                fill='url(#paint3_linear)'
            />
            <defs>
              <linearGradient
                  id='paint0_linear'
                  x1='158.5'
                  y1='107'
                  x2='-24'
                  y2='-23'
                  gradientUnits='userSpaceOnUse'
              >
                <stop stopColor='#0FA620' />
                <stop offset='1' stopColor='#7BB7FB' />
              </linearGradient>
              <linearGradient
                  id='paint1_linear'
                  x1='158.5'
                  y1='107'
                  x2='-24'
                  y2='-23'
                  gradientUnits='userSpaceOnUse'
              >
                <stop stopColor='#0FA620' />
                <stop offset='1' stopColor='#7BB7FB' />
              </linearGradient>
              <linearGradient
                  id='paint2_linear'
                  x1='158.5'
                  y1='107'
                  x2='-24'
                  y2='-23'
                  gradientUnits='userSpaceOnUse'
              >
                <stop stopColor='#0FA620' />
                <stop offset='1' stopColor='#7BB7FB' />
              </linearGradient>
              <linearGradient
                  id='paint3_linear'
                  x1='158.5'
                  y1='107'
                  x2='-24'
                  y2='-23'
                  gradientUnits='userSpaceOnUse'
              >
                <stop stopColor='#0FA620' />
                <stop offset='1' stopColor='#7BB7FB' />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <p className='text-sm font-medium tracking-wide bg-gradient-to-r from-gray-400 via-white to-gray-400 bg-clip-text text-transparent animate-shimmer'>
          Loading, please wait...
        </p>
      </div>
    </div>
  );
};
